import CodeBase from "./CodeBase.js"

// 시나리오 제공서비스 유형

class ScenarioCallType extends CodeBase {
  constructor() {
    const CODE_MAP = {
      'A' : '아웃바운드콜',
      'B' : '인바운드콜'
    };

    super(CODE_MAP);
  }
}

export default ScenarioCallType;
